import { render, staticRenderFns } from "./mr_duo_resolve_dependency_bump.vue?vue&type=template&id=9795c49a"
import script from "./mr_duo_resolve_dependency_bump.vue?vue&type=script&lang=js"
export * from "./mr_duo_resolve_dependency_bump.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports